module.exports = __webpack_public_path__ + "static/media/480.383108d0.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/services/img/i8-field/light/480.png
// module id = 2044
// module chunks = 2